import { apiClient } from '../lib/api-client';
import type { ScanStatus } from '@sdd-maturity/shared-types';
import { usePolledStatus } from '../hooks/usePolledStatus';
import { TERMINAL_STATES } from '../lib/scanStatus';
import { ScanStatusCard } from './ScanStatusCard';

export interface ScanProgressProps {
  executionArn: string;
  onComplete?: () => void;
}

/**
 * Polls scan status every 5 seconds until terminal state.
 * Displays current status, start time, and result summary.
 */
export function ScanProgress({ executionArn, onComplete }: ScanProgressProps) {
  const { status, error } = usePolledStatus<ScanStatus>(
    (arn, token) => apiClient.getScanStatus(arn, token),
    executionArn,
    onComplete,
  );

  const resultText =
    status && TERMINAL_STATES.has(status.status)
      ? status.output?.reposScanned != null
        ? `${status.output.reposScanned} repos scanned, ${status.output.reposFailed ?? 0} failed`
        : status.status === 'SUCCEEDED'
          ? 'Scan completed successfully'
          : status.errorMessage
            ? status.errorMessage
            : 'Scan did not complete'
      : '';

  return <ScanStatusCard status={status} error={error} testId="scan-progress" resultText={resultText} />;
}
